import { Link } from 'react-router-dom';
import { FOOTER_COLS } from '@/data/wft';
import { Reveal } from '@/components/fx/Reveal';

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="shell">
        <Reveal className="site-footer__top">
          <div>
            <img
              className="site-footer__mark"
              src="/logo.png"
              alt=""
              width={54}
              height={54}
              loading="lazy"
              decoding="async"
            />
            <p className="eyebrow">World Finance Terminal</p>
            <p className="site-footer__claim">
              Forecasts written first.
              <br />
              <span className="gradient-text">Scored later.</span> Published either way.
            </p>
          </div>

          <nav className="site-footer__cols" aria-label="Footer">
            {FOOTER_COLS.map((col) => (
              <div key={col.title} className="site-footer__col">
                <p className="site-footer__colTitle">{col.title}</p>
                <ul>
                  {col.links.map((link) => (
                    <li key={`${col.title}-${link.label}`}>
                      <Link to={link.href}>{link.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </nav>
        </Reveal>

        <div className="site-footer__base">
          <span>World Finance Terminal · v0.1.0 · by GodEngine</span>
          <span>No number here comes from anywhere but a named source.</span>
        </div>
      </div>
    </footer>
  );
}
